<div class="modal-content">
  <button aria-label="Close" class="close" (click)="activeModal.dismiss()" type="button">
    <span class="fas fa-times"></span>
  </button>
  <div class="onboarding-content">
    <h4 class="onboarding-title">
      {{ 'HotelReservations.AttachedReservations' | translate }}
    </h4>
    <div class="ar-body">
      <div class="reservation-header">
        <h5>
          {{ selectedReservation?.guestInfo?.name }}
          {{ selectedReservation?.guestInfo?.firstName }}
          <ng-template [ngIf]="selectedReservation?.displayName"> ({{ selectedReservation?.displayName }})</ng-template>
          ({{ selectedReservation.guestCount }})
        </h5>

        <div>
          <span *ngIf="selectedReservation?.type" class="badge bg-light">
            {{ selectedReservation.type }}
          </span>

          <span *ngIf="selectedReservation?.attachedCode" class="fw-bold">
            {{ selectedReservation.attachedCode }}
          </span>
        </div>

        <div *ngIf="selectedReservation?.roomNoAll">
          {{ 'HotelReservations.Room' | translate }}: {{ selectedReservation.roomNoAll }}
        </div>

        <div *ngIf="selectedReservation?.cateringPackage">{{ selectedReservation?.cateringPackage }}</div>
      </div>

      <div class="ar-row" *ngFor="let row of selectedReservation?.attachedReservationsCustom">
        <!-- ===== LINE 1 ===== -->
        <div class="ar-line ar-line-1">
          <div class="ar-guest">
            {{ row.guestInfo?.name }} {{ row.guestInfo?.firstName }}
            <span class="ar-count">({{ row.guestCount }})</span>
          </div>

          <div class="ar-right">
            <span *ngIf="row.board" class="badge" [ngStyle]="{ background: fetchColor(row.board) }">
              {{ row.board }}
            </span>

            <span class="ar-resno"> #{{ row.reservationNo }} </span>
          </div>
        </div>

        <!-- ===== LINE 2 ===== -->
        <div class="ar-line ar-dates">
          {{ row.arrivalDate | amDateFormat: 'DD.MM.YYYY' }}
          →
          {{ row.departureDate | amDateFormat: 'DD.MM.YYYY' }}
        </div>

        <!-- ===== LINE 3 ===== -->
        <div class="ar-line ar-contact" *ngIf="row.guestInfo?.email || row.guestInfo?.phone">
          <span *ngIf="row.guestInfo?.email">
            {{ row.guestInfo?.email }}
          </span>

          <span *ngIf="row.guestInfo?.phone">
            {{ row.guestInfo?.phone }}
          </span>
        </div>

        <!-- EXTRA DETAILS -->
        <div class="ar-extra" *ngIf="row.roomNo || row.notes || row.guestInfo?.guestNotes || row.reservationInfo">
          <div *ngIf="row.roomNo">{{ 'HotelReservations.Room' | translate }}: {{ row.roomNo }}</div>

          <div *ngIf="row.notes">
            <strong>{{ 'HotelReservations.Notes' | translate }}:</strong> {{ row.notes }}
          </div>

          <div *ngIf="row.guestInfo?.guestNotes">
            <strong>{{ 'HotelReservations.GuestNotes' | translate }}:</strong> {{ row.guestInfo?.guestNotes }}
          </div>
          <div *ngIf="row.reservationInfo">
            <div *ngFor="let item of row.reservationInfo | keyvalue">
              <ng-template [ngIf]="item.value">
                <strong>{{ item.key }}:</strong>
                <span [class.preline]="item.value?.length > 20">
                  {{ item.value }}
                </span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
